var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-layout',{attrs:{"top":20},scopedSlots:_vm._u([{key:"main",fn:function(){return [_c('stepper')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }